import { Box, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  status: string
}
export const StatusTag = ({ status }: Props) => {
  const getStatusColor = () => {
    switch (status) {
      case 'approved':
        return 'lime'
      case 'draft':
        return 'grey'
      case 'rejected':
        return 'radical'
      case 'review':
        return 'champagne'
      default:
        return 'grey'
    }
  }

  const getTagTranslation = () => {
    switch (status) {
      case 'approved':
        return i18n.t('trainings.training_requests.my_requests.datatable.status_tag.approved')
      case 'draft':
        return i18n.t('trainings.training_requests.my_requests.datatable.status_tag.draft')
      case 'rejected':
        return i18n.t('trainings.training_requests.my_requests.datatable.status_tag.rejected')
      case 'review':
        return i18n.t('trainings.training_requests.my_requests.datatable.status_tag.pending')
      default:
        return status
    }
  }

  return (
    <Box width="fit-content">
      <Tag leftItem="circle" showCircle type={getStatusColor()}>
        {getTagTranslation()}
      </Tag>
    </Box>
  )
}
